import { z } from 'zod';

export const StewardUtilityPreferencesSchema = z.object({
  id: z.literal('default'), electricityEnabled: z.boolean(), waterEnabled: z.boolean(), updatedAt: z.string().datetime(),
}).strict();
export type StewardUtilityPreferences = z.infer<typeof StewardUtilityPreferencesSchema>;
